import { render, staticRenderFns } from "./Columnists.vue?vue&type=template&id=58208a43&"
import script from "./Columnists.vue?vue&type=script&lang=js&"
export * from "./Columnists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports